// Map a stored icon name onto the string Vuetify's <v-icon> expects.
//
// Categories come back from the API with icons in several notations (MDI,
// Font Awesome 5/6, bare material names). Extracted here because both
// ItemsGrid's template and useItemsGridData's row mapping need it.

// A Font Awesome class list that already names its style: FA5's short prefixes (`fas`, `far`,
// `fab`) or FA6's long ones (`fa-solid`, `fa-regular`, `fa-brands`). Until 2026-10-28 only `fas`
// and `fab` were recognised, so a `far fa-*` category icon (PO's "Permits", `far fa-address-card`)
// fell through to the material branch and rendered its name as text.
const FA_STYLED = /^(fas|far|fab|fa-solid|fa-regular|fa-brands) fa-/;

export const getIconClass = (icon) => {
  if (!icon) return 'mdi-help-circle';

  if (icon.startsWith('mdi-')) {
    return icon; // Already in correct format for MDI
  } else if (FA_STYLED.test(icon)) {
    // For Font Awesome 6 in Vuetify 3, the class list goes through as-is:
    return `fa:${icon}`;
  } else if (icon.startsWith('fa-')) {
    // If just fa- prefix is used, assume it's a solid icon
    return `fa:fas ${icon}`;
  } else {
    // For material icons
    return `md:${icon}`;
  }
};
